interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const FlowArrowDIcon = (props: PropsType) => (
  <svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 1.14209L16.1421 15.2842L30.2843 1.14209" stroke="#E60012" strokeWidth="3" />
  </svg>
);

export default FlowArrowDIcon;
